import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: 24px;
  max-width: 100%;
  position: relative;
  user-select: none;
  width: 100%;

  ${media.greaterThan("medium")`
    min-width: 250px;
  `}
`;

export const ProfileWrapper = styled.div`
  align-self: baseline;
  display: grid;
  grid-gap: 12px;
  grid-template-columns: 36px auto 24px;
  height: 36px;
  width: 100%;

  cursor: pointer;

  ${media.greaterThan("medium")`
    place-items: center;
  `}

  span {
    transition: 0.5s ease all;
    transform: ${({ $active }) => ($active ? "rotateX(180deg)" : "rotateX(0)")};
    align-self: center;
  }
`;

export const ProfileBorder = styled.div`
  background-image: ${({ theme }) => theme.colors.gradient.gradientLogo};
  border-radius: 50%;
  height: 36px;
  padding: 2px;
  width: 36px;
`;

export const ProfileImage = styled.img`
  background-color: ${({ theme }) => theme.colors.neutral.gray8};
  border-radius: 50%;
  height: 100%;
  max-height: 36px;
  width: 100%;
`;

export const InfosWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  justify-self: start;
`;

export const Name = styled.p`
  color: ${({ theme }) => theme.colors.neutral.white};
  ${({ theme }) => theme.font.body.sm};
  ${({ theme }) => theme.font.weight.medium};
  max-width: 125px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Email = styled.p`
  color: ${({ theme }) => theme.colors.neutral.gray5};
  ${({ theme }) => theme.font.body.xs}
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${media.greaterThan("medium")`
    background-color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
    border-radius: 8px;
    position: absolute;
    right: 10px;
    top: 80px;
    width: 250px;
    z-index: 10;
  `}
`;

export const Option = styled.div`
  color: ${({ theme }) => theme.colors.neutral.white};
  ${({ theme }) => theme.font.body.sm};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 20px 10px;
  width: 100%;

  :hover {
    color: ${({ theme }) => theme.colors.hues.cetaceanShade1};
    svg path {
      fill: ${({ theme }) => theme.colors.hues.cetaceanShade1};
    }
  }

  cursor: pointer;

  span {
    display: block;
  }

  ${media.greaterThan("medium")`
    padding: 21px 22px;
  `}
`;

export const Notifications = styled.div`
  position: relative;
  cursor: pointer;
`;

export const NotificationDot = styled.div`
  /* Vermelho (D5 da parte 4): o badge deixou de anunciar "ha notificacao" e
     passou a anunciar ALERTA — algo que exige acao. O token
     feedbackState.critical existe nos DOIS temas; feedback.error so existe no
     comum e quebraria o admin.
     ATENCAO: nada de crase neste comentario — ele vive dentro de um template
     literal do styled-components, e a crase ENCERRA o template. */
  background-color: ${({ theme }) =>
    theme.colors.feedbackState.critical.default};
  border-radius: 50%;
  height: 8px;
  width: 8px;
  position: absolute;
  top: 0;
  right: 0;
`;
